import React from 'react';
import { ScrollArea } from '../ui/scroll-area';
import { Button } from '../ui/button';
import { History, Trash2 } from 'lucide-react';
import { cn } from '../../lib/utils';

export function CombatLog({ combatLog, language, onClear }) {
  return (
    <div className="w-72 border-l border-border bg-card/50 flex flex-col">
      <div className="p-3 border-b border-border flex items-center justify-between">
        <h3 className="font-semibold flex items-center gap-2">
          <History className="h-4 w-4" />
          {language === 'fr' ? 'Journal de combat' : 'Combat Log'}
        </h3>
        <Button variant="ghost" size="icon" className="h-6 w-6" onClick={onClear}>
          <Trash2 className="h-3 w-3" />
        </Button>
      </div>
      <ScrollArea className="flex-1">
        <div className="p-2 space-y-1">
          {combatLog.length === 0 ? (
            <p className="text-xs text-muted-foreground text-center py-4">
              {language === 'fr' ? 'Aucune action' : 'No actions'}
            </p>
          ) : (
            combatLog.map(entry => (
              <div 
                key={entry.id}
                className={cn(
                  "text-xs p-2 rounded",
                  entry.type === 'damage' && "bg-red-500/10 text-red-400",
                  entry.type === 'heal' && "bg-green-500/10 text-green-400",
                  entry.type === 'roll' && "bg-blue-500/10 text-blue-400",
                  entry.type === 'combat' && "bg-yellow-500/10 text-yellow-400",
                  entry.type === 'turn' && "bg-purple-500/10 text-purple-400",
                  entry.type === 'add' && "bg-cyan-500/10 text-cyan-400",
                  entry.type === 'condition' && "bg-orange-500/10 text-orange-400",
                  entry.type === 'death' && "bg-gray-800 text-gray-300 border border-red-500/50",
                  entry.type === 'info' && "bg-secondary"
                )}
              >
                <span className="opacity-60">[{entry.timestamp}]</span> {entry.message}
              </div>
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
